const GameOnboardingInstructionCreateWalletMobile = () => {
  return (
    <ul>
      <li>Open the MetaMask app or extension.</li>
      <li>If this is your first time using MetaMask, select "Create a New Wallet".</li>
      <li>
        Follow the on-screen instructions. Ensure you write down and safely store your recovery phrase. It's crucial for
        restoring your wallet in case you lose access.
      </li>
      <li>
        Once your wallet is created, you will be directed to the main interface showing your account balance and other
        details.
      </li>
    </ul>
  );
};

export default GameOnboardingInstructionCreateWalletMobile;
